/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React from 'react';
import { Select,Icon,Form,Row, Col, InputNumber,Modal, Table, Button, Popconfirm, message, Input, } from 'antd';
import { withRouter } from "react-router-dom";
import API_URL from '../../constants/API_URL';
const axios = require('axios');
const FormItem = Form.Item
class CustomerSetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: {},
      loading: false,
      pageNumber: 0,
      parameters: [],
      name: '',
      phoneNo: '',
      email: '',
      building: '',
      street: '',
      flatNo: '',
      selectedPayMthd: null,
      landmark: '',
      visible: false,
      customer:{},
      paymentMethodsList: [],
      payLoading: false,
    };
    
    this.lang = this.props.language.INJAZ_POS_CUSTOMER.SETUP;
    this.columns = [{
      title: (
        <span>
          {this.lang.TABLEHEADERS.NAME}
          <br /><Input.Search
            type="text" name="name" onChange={this.onChangeSearch} />
        </span>
      ),
      dataIndex: 'name',
      sorter: true,
      render: (text, record) => <button  onClick={() => {
        this.props.handleNavigation(record)
        }}  className="link-button">{text}</button>,
    },

    {
      title:
        (
          <span>
            {this.lang.TABLEHEADERS.PHONE}
            <br /><Input.Search type="text" name="phoneNo" onChange={this.onChangeSearch} />
          </span>
        ),
      dataIndex: 'phoneNo',
      sorter: true,
      render: (text, record) => <button  onClick={() => {
        this.props.handleNavigation(record)
        }}  className="link-button">{text}</button>

    },
    
   
    {
      title:
        (
          <span>
            {this.lang.TABLEHEADERS.COLLPOINTS}
            <br /><Input.Search type="text" name="collectPoints" onChange={this.onChangeSearch} />
          </span>
        ),
      dataIndex: 'collectPoints',
      sorter: true,
      render: (text, record) => <button  onClick={() => {
        this.props.handleNavigation(record)
        }}  className="link-button">{text}</button>

    },
   
    {
      title:
        (
          <span>
            {this.lang.TABLEHEADERS.BUILDING}
            <br /><Input.Search type="text" name="building" onChange={this.onChangeSearch} />
          </span>
        ),
      dataIndex: 'building',
      sorter: true,
      render: (text, record) => <button  onClick={() => {
        this.props.handleNavigation(record)
        }}  className="link-button">{text}</button>

    },
    {
      title:
        (
          <span>
            {this.lang.TABLEHEADERS.STREET}
            <br /><Input.Search type="text" name="street" onChange={this.onChangeSearch} />
          </span>
        ),
      dataIndex: 'street',
      sorter: true,
      render: (text, record) => <button  onClick={() => {
        this.props.handleNavigation(record)
        }}  className="link-button">{text}</button>

    },
    {
      title:
        (
          <span>
            {this.lang.TABLEHEADERS.FLATNO}
            <br /><Input.Search type="text" name="flatno" onChange={this.onChangeSearch} />
          </span>
        ),
      dataIndex: 'flatNo',
      sorter: true,

      render: (text, record) => <button onClick={() => {
        this.props.handleNavigation(record)
        }} className="link-button">{text}</button>

    },
    {
      title:
        (
          <span>
            {this.lang.TABLEHEADERS.DEBTAMNT}
            <br /><Input.Search type="text" name="landmark" onChange={this.onChangeSearch} />
          </span>
        ),
      dataIndex: 'debitAmt',
      sorter: true,
      render: (text, record) => <button onClick={() => {
        this.props.handleNavigation(record)
        }} className="link-button">{text}</button>

    },
    {
      title:
        (
          <span>
            {this.lang.TABLEHEADERS.ACTION}
            <br /><Input.Search type="text" name="landmark" onChange={this.onChangeSearch} />
          </span>
        ),
      dataIndex: 'operation',
      sorter: true,
      render: (text, record) => <button onClick={() => {this.setState({customer: {...record}},() => this.setState({visible:true}))
      }} className="link-button" disabled={record.debitAmt <= 0} style={{padding: "4px",backgroundColor: "#CC0000", color: "#fff"}} type="primary">Payment</button>

    },
    {
      title: this.lang.TABLEHEADERS.ACTION,
      dataIndex: 'operation',
      render: (text, record) => {

        return (
          <div>

            <div>
              <span style={{ marginLeft: "5" }}>
                <Popconfirm
                  title={this.lang.DELETEPOPUP.TITLE}
                  onConfirm={() => this.delete(record)}
                  cancelText={this.lang.DELETEPOPUP.CANCELBUTTON}
                  okText={this.lang.DELETEPOPUP.DELETEBUTTON}
                >
                  <button className="link-button"> <Icon type="delete" theme="outlined" className="deleteiconclass" /></button>
                </Popconfirm>
              </span>
            </div>

          </div>
        );
      },
    }


    ];
  }

  selectPaymentMethd = (v) => {
    this.setState({ selectedPayMthd: v })
  }
  payment = () => {
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    axios({
      method: 'POST',
      url: API_URL + 'payCustomerDebit',
      data: {
        payMethod: this.state.selectedPayMthd,
        branch: JSON.parse(localStorage.getItem("userData")).branchId,
        lang: localStorage.getItem("lang"),
        customer: this.state.customer.id,
        paymentAmt: this.state.payAmt
      },
      headers: {
        'Authorization': tokenType + ' ' + accessToken,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (res.data.success) {
          this.setState({ visible: false, selectedPayMthd: null, payAmt: null, payLoading: false })
          this.fetch()
          message.success(res.data.message)
        } else {
          this.setState({   payLoading: false })
          message.error(res.data.message)
        }
      })
  }
  handleCancel = () => {
    this.setState({   visible: false, selectedPayMthd: null, payAmt: null, payLoading: false })
  };
  onChangeSearch = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.fetch()
    })
  }
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (

        <div style={{ padding: 8 }}>
          <Input
            ref={node => { this.searchInput = node; }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm, setSelectedKeys)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
        </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
        </Button>
        </div>
      ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.value);
      }
    },
    render: (text) => (
      <p>text</p>
    ),
  })


  handleSearch = (selectedKeys, confirm) => {
    confirm();
    //console.log(selectedKeys[0]);
    this.setState({ searchText: selectedKeys[0] });
    this.fetch({ name: selectedKeys[0], nameAr: selectedKeys[1], description: selectedKeys[2], address: selectedKeys[3] });
  }
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
    this.fetch();
 }

   handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
      pageNumber: this.state.pageNumber + 1
    });
    //console.log(sorter)
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    });
  }
  componentDidMount() {
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let self = this;
    var authOptions = {
      method: 'GET',
      url: API_URL + 'parametersList',
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang")
      },
      headers: {
        'Authorization': tokenType + ' ' + accessToken,
        'Content-Type': 'application/json'
      }
    }
    self = this
    axios(authOptions)
      .then(function (response) {
        // message.success(response.data.message);
        //console.log(response.data)
        self.setState({
          parameters: response.data
        })

      })
      .catch(function (error) {
        //message.error(error.response.data.message);
      });
    this.fetch();
    axios({
      method: 'GET',
      url: API_URL + 'paymentMethodsList',
      params: {
        clientId: localStorage.getItem('clientId'),
        lang: localStorage.getItem('lang')
      },    headers: {
        'Authorization': tokenType + ' ' + accessToken,
        'Content-Type': 'application/json'
      },
    })
      .then(res => {
        this.setState({ paymentMethodsList: res.data })
      })
      .catch(err => { })
  }
  delete(record) {
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let id = record.id;
    let lang = localStorage.getItem("lang");

    axios({
      url: API_URL + 'deleteCustomer',
      method: 'POST',
      data: {
        "id": id,
        "lang": lang
      },
      headers: {
        'Authorization': tokenType + ' ' + accessToken,
        'Content-Type': 'application/json'
      }
    }).then((data) => {
      message.success(data.data.message);
      this.fetch();


    });
  }
  handleOk = () => {
    this.setState({ payLoading: true })
    if (this.state.payAmt && this.state.selectedPayMthd) {
      this.payment()
    }
  };
  filterByBranch = (v) => {
    this.fetch({ parent: v })
    this.setState({ parent: v })

  }

  fetch = (params = {}) => {
    //console.log('params:', params);
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId")
    let lang = localStorage.getItem("lang");
    let page;
    let sortOrder = ''

    this.setState({ loading: true });
    if (params.page) {
      page = params.page - 1
    }
    else {
      page = 0;
    }
    if (params.sortOrder == 'ascend') {
      sortOrder = 'ASC'
    }
    else {
      sortOrder = 'DESC'
    }
    let nameAr
    if (params.nameAr) {
      nameAr = params.nameAr[0]
    }
    let description
    if (params.description) {
      description = params.description[0]
    }
    let address
    if (params.address) {
      address = params.address[0]
    }
    let data = {
      lang,
      clientId: clientId,
      page,
      size: 10,
      name: params.name || this.state.name || '',
      phoneNo: params.phoneNo || this.state.phoneNo || '',
      email: params.email || this.state.email || '',
      building: params.building || this.state.building || '',
      street: params.street || this.state.street || '',
      flatNo: params.flatNo || this.state.flatNo || '',
      landmark: params.landmark || this.state.landmark || '',



      sortColumn: params.sortField,
      sortOrder,
      isParent: params.isParent || ''
    }
    if (params.parent) {
      data.parent = params.parent
    } else if (this.state.parent) {
      data.parent = this.state.parent
    }
    //console.log(data)
    axios({
      url: API_URL + 'customersByClient',
      method: 'POST',
      data,
      headers: {
        'Authorization': tokenType + ' ' + accessToken,
        'Content-Type': 'application/json'
      }
    }).then((data) => {
      console.log(data);
      const pagination = { ...this.state.pagination };
      pagination.total = data.data.totalElements;
      //console.log(pagination);
      this.setState({
        loading: false,
        data: data.data.content,
        pagination,
      });
    });
  }



  render() {
    return (
      <div >
        <Table
          style={{ marginTop: '10px' }}
          columns={this.columns}
          dataSource={this.state.data}
          pagination={this.state.pagination}
          loading={this.state.loading}
          onChange={this.handleTableChange}
          rowKey="id"
          onRow={(record, rowIndex) => {
            return {
              onClick: event => {
                this.props.handleNavigation(record)
              }, // click row
            };
          }}
      
        />
        {
          this.state.visible && 
        <Modal
            title="Payment"
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={[
            <Button key="back" disabled={this.state.payLoading} onClick={this.handleCancel}>
              Cancel
            </Button>,
            <Button 
              key="submit" 
              type="primary" 
              disabled={(this.state.selectedPayMthd && this.state.payAmt) ? false : true} 
              loading={this.state.payLoading} 
              onClick={this.handleOk}
            >
              Pay
            </Button>,
          ]}
          >
            <Row gutter={24}>
              <Col span={24}>
                <p><span style={{ fontWeight: "bold" }}>Debit Amount:</span> {this.state.customer.debitAmt}</p>
              </Col>
              <Col span={24}>
                <FormItem label={"Payment Method"}>
                  <Select 
                    value={this.state.selectedPayMthd}
                    style={{ width: '100%', background: '#fff' }} 
                    onChange={this.selectPaymentMethd} placeholder="Select Payment Method">
                    {
                      this.state.paymentMethodsList.map(item => (
                        <Select.Option value={item.id} key={item.id} >{item.name}</Select.Option>
                      ))
                    }
                  </Select>
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem label={"Payment Amount"}>
                  <InputNumber
                    onChange={(v) => this.setState({ payAmt: v })}
                    max={this.state.customer.debitAmt}
                    value={this.state.payAmt}
                    min={0}
                    formatter={value => `SAR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={value => value.replace(/\SAR\s?|(,*)/g, '')}
                    style={{ width: '100%' }} placeholder={"Enter Amount"} dir={this.props.language.INJAZ_AUTH_DIRECTION} />
                </FormItem>
              </Col>
            </Row>
          </Modal>
        }
      </div>
    );
  }
}


export default withRouter(CustomerSetup)
